import { z } from 'zod';

/**
 * Where a place's initial values came from.
 *
 * Mirrors the `places.provider` column (docs/03-domain-model.md 3.3). It is a
 * property of the *row*, not of the request: a place registered by hand is
 * `manual` even if the user had a Google suggestion open in another tab.
 */
export const placeProviderSchema = z.enum(['google', 'manual', 'overture']);
export type PlaceProvider = z.infer<typeof placeProviderSchema>;

/**
 * Providers whose content may NOT be persisted beyond the place id.
 *
 * Google Maps Platform allows `place_id` to be stored indefinitely and nothing
 * else (docs/05-map-and-places.md 5.2). This list is what the type system and
 * the runtime checks in `@mapshare/core` and `@mapshare/places` are built
 * around; adding a provider here is how a new terms restriction is expressed.
 */
export const CONTENT_RESTRICTED_PROVIDERS: readonly PlaceProvider[] = ['google'];

export function isContentRestrictedProvider(provider: PlaceProvider): boolean {
  return CONTENT_RESTRICTED_PROVIDERS.includes(provider);
}
